import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';
import { CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { HeaderService } from '../header/header.service';
import { getPath, PathUnit } from '@/app/consts/path.const';
import { RoleEnum } from '@/app/consts/role.const';
import { AllAppLinks, AppLink } from '@/app/consts/app-links.config';
import { HasRoleDirective } from '@/app/directives/has-role.directive';

interface NavItem {
  label: string;
  icon?: string;
  route?: string;
  children?: NavItem[];
  withRoles?: RoleEnum[];
}

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [CommonModule, RouterModule, TegelModule, HasRoleDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  protected headerService = inject(HeaderService);

  // User profile properties
  userName = 'John Doe';
  placeOfWork = 'Scania';

  // Mobile menu state
  mobileNavOpen = this.headerService.mobileNavOpen;

  navItems: AppLink[];

  constructor() {
    // Initialize navItems filtering out hidden items
    this.navItems = this.filterNavItems(AllAppLinks);
    // Ensure side menu is visible
    if (typeof document !== 'undefined') {
      setTimeout(() => {
        const sideMenu = document.querySelector('tds-side-menu');
        if (sideMenu) {
          sideMenu.setAttribute('style', 'display: block; height: 100%;');
        }
      });
    }
  }

  private filterNavItems(links: AppLink[]): AppLink[] {
    return links
      .filter(link => !link.isHideInSideNav)
      .map(link => ({
        ...link,
        children: link.children ? this.filterNavItems(link.children) : undefined
      }));
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
    this.closeMobileSideMenu();
  }

  closeMobileSideMenu(): void {
    this.headerService.closeMobileSideMenu();
  }

  toggleMobileSideMenu(): void {
    this.headerService.toggleMobileSideMenu();
  }

  isActive(route: string | undefined): boolean {
    return this.router.url === `/${route}`;
  }

  isActiveChild(navItem: NavItem) {
    return navItem.children?.some(nav => this.router.url === `/${nav.route}`);
  }

  onSubRoute(route: string): boolean {
    return this.router.url.startsWith(route);
  }
}